import React, { lazy } from "react";
import { useParams } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import LocalizedRedirect from "./LocalizedRedirect";
import { ROUTE_MAP } from "../constants/routes";

// Landing modułu — ten sam chunk co w App.js (webpack deduplikuje import o tej samej ścieżce).
const ItManagementPage = lazy(() => import("../pages/it/ItManagementPage"));

/**
 * [MODUŁY DYNAMICZNE 2026-07-31] Resolver automatycznych adresów /obsluga-<kod>.
 *
 * React Router v7 nie wyraża parametru wewnątrz segmentu ("/obsluga-:kod" jest NIEWYRAŻALNE),
 * więc cały segment łapie trasa ":slug" (ostatnia w Layout — trasy statyczne i tak ZAWSZE
 * wygrywają ranking z parametrem) i dopiero tutaj rozstrzygamy:
 *  - slug "obsluga-<kod>" → landing modułu zgłoszeń (ItManagementPage z moduleCodeOverride),
 *    w TEJ SAMEJ bramce co trasy ticketowe (ProtectedRoute TicketView);
 *  - slug będący znaną trasą statyczną w DRUGIM języku (np. /obsluga-it w trybie EN) albo
 *    dowolny nieznany adres → LocalizedRedirect, czyli dokładnie to, co robił catch-all "*".
 *
 * Adres /obsluga-<kod> jest surowy i WSPÓLNY dla obu języków — celowo bez wpisu w ROUTE_MAP
 * (wpis regexowy byłby ryzykowny); translateCurrentPath zwraca nieznane ścieżki bez zmian,
 * więc przełączenie języka nie psuje tych adresów.
 */
const isKnownStaticPath = (pathname) =>
    Object.values(ROUTE_MAP).some((paths) => paths.pl === pathname || paths.en === pathname);

const ModuleSlugRoute = () => {
    const { slug } = useParams();
    const match = /^obsluga-(.+)$/.exec(slug || "");

    if (!match || isKnownStaticPath(`/${slug}`)) {
        return <LocalizedRedirect />;
    }

    return (
        <ProtectedRoute requiredPermission="TicketView" moduleLabel="Obsługa zgłoszeń">
            <ItManagementPage moduleCodeOverride={match[1]} />
        </ProtectedRoute>
    );
};

export default ModuleSlugRoute;
